import script from "./productSystemMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./productSystemMobile.vue?vue&type=script&setup=true&lang=js"

import "./productSystemMobile.vue?vue&type=style&index=0&id=17d0999f&lang=less&scoped=true"
import "./productSystemMobile.vue?vue&type=style&index=1&id=17d0999f&lang=css"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17d0999f"]])

export default __exports__